import { defineMessages } from 'react-intl';

export default defineMessages({
    Boats: {
        id: 'quoteandbind.RecMarLinedirectives.views.boatsPage.Boats',
        defaultMessage: 'Boats'
    },
    boat: {
        id: 'quoteandbind.RecMarLinedirectives.views.boatsPage.Boat',
        defaultMessage: 'Boat'
    },
    AddBoatDetails: {
        id: 'quoteandbind.RecMarLinedirectives.views.boatsPage.Add Boat Details',
        defaultMessage: 'Add Boat Details'
    },
    remove: {
        id: 'quoteandbind.RecMarLinedirectives.views.boatsPage.Remove',
        defaultMessage: 'Remove'
    },
     boatCount: {
        id: 'quoteandbind.RecMarLinedirectives.views.boatsPage.Boat count',
        defaultMessage: 'Boat {count}'
    },
});